class SliderShuffleArtikel extends HTMLElement {
  // Anzahl kompletter Durchläufe vor dem Stopp
  static SPIN_ROUNDS = 2;

  connectedCallback() {
    // Alle Slot-Viewports der Komponente erfassen
    this.slotViewports = this.querySelectorAll('.slot-viewport');

    // Button zum Starten des Shuffle-Effekts
    this.shuffleButton = this.querySelector('.cta-shuffle');

    // Verhindert, dass während einer laufenden Animation ein neuer Shuffle startet
    this.isAnimating = false;

    this.initializeSlots();
    this.attachEventListeners();
  }

  initializeSlots() {
    this.slotViewports.forEach((viewport) => {
      this.updateTabIndices(viewport);
    });
  }

  updateTabIndices(viewport) {
    const band = viewport.querySelector('.slot-band');
    const items = band.querySelectorAll('.slot-item:not(.clone)');

    items.forEach((item, index) => {
      const links = item.querySelectorAll('a, button, input, select, textarea');

      if (index === 0) {
        // Erstes Item ist sichtbar, interaktive Elemente fokussierbar
        links.forEach(link => link.removeAttribute('tabindex'));
      } else {
        // Alle anderen Items nicht per Tastatur erreichbar
        links.forEach(link => link.setAttribute('tabindex', '-1'));
      }
    });
  }

  attachEventListeners() {
    if (this.shuffleButton) {
      this.shuffleButton.addEventListener('click', () => this.shuffle());
    }
  }

  shuffle() {
    if (this.isAnimating) return;
    this.isAnimating = true;

    let completedAnimations = 0;
    const totalAnimations = this.slotViewports.length;

    this.slotViewports.forEach((viewport) => {
      const band = viewport.querySelector('.slot-band');
      const items = Array.from(band.querySelectorAll('.slot-item'));
      const itemCount = items.length;
      const isReverse = viewport.classList.contains('second');

      // Anzahl der zu klonenden Items: SPIN_ROUNDS komplette Durchläufe + 1 für Endposition
      const cloneCount = SliderShuffleArtikel.SPIN_ROUNDS * itemCount + 1;

      if (isReverse) {
        // Items rückwärts klonen und am Anfang einfügen
        for (let i = 0; i < cloneCount; i++) {
          const sourceIndex = (itemCount - 1) - (i % itemCount);
          const clone = items[sourceIndex].cloneNode(true);
          clone.classList.add('clone');
          band.insertBefore(clone, band.firstChild);
        }

        // CSS-Variable für Animationsdistanz setzen
        band.style.setProperty('--spin-distance', cloneCount);

        // Band auf Startposition setzen (verschoben um die Klone)
        band.style.transform = `translateY(calc(-1 * ${cloneCount} * (var(--item-height) + var(--item-gap))))`;
        band.offsetHeight; // Reflow erzwingen
      } else {
        // Items vorwärts klonen und ans Ende anhängen
        for (let i = 0; i < cloneCount; i++) {
          const sourceIndex = i % itemCount;
          const clone = items[sourceIndex].cloneNode(true);
          clone.classList.add('clone');
          band.appendChild(clone);
        }

        // CSS-Variable für Animationsdistanz setzen
        band.style.setProperty('--spin-distance', cloneCount);
      }

      // Animation starten
      band.classList.add('spinning');

      band.addEventListener('animationend', () => {
        band.classList.remove('spinning');

        // Alle Klone entfernen
        band.querySelectorAll('.slot-item.clone').forEach(clone => clone.remove());

        if (isReverse) {
          // Letztes Original-Item an den Anfang verschieben
          const lastItem = band.querySelector('.slot-item:last-child');
          band.insertBefore(lastItem, band.firstChild);
        } else {
          // Erstes Original-Item ans Ende verschieben
          const firstItem = band.querySelector('.slot-item');
          band.appendChild(firstItem);
        }

        // Position und CSS-Variablen zurücksetzen
        band.style.transition = 'none';
        band.style.transform = '';
        band.style.setProperty('--spin-distance', 0);
        band.offsetHeight; // Reflow erzwingen
        band.style.transition = '';

        // Accessibility aktualisieren
        this.updateTabIndices(viewport);

        completedAnimations++;
        if (completedAnimations === totalAnimations) {
          this.isAnimating = false;
        }
      }, { once: true });
    });
  }
}

if (!customElements.get("slider-shuffle-artikel")) {
  customElements.define("slider-shuffle-artikel", SliderShuffleArtikel);
}
